import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SessionTimeoutButtons } from '../models/modal-timeout.config';

@Component({
    selector: 'carm-timeout-modal-dialog',
    templateUrl: './timeout-modal.component.html',
    styleUrls: ['./timeout-modal.component.scss'],
  })

  export class TimeoutModalComponent {
    sessionTimeOutBtn = SessionTimeoutButtons;
    constructor(
        public dialogRef: MatDialogRef<TimeoutModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
            dialogRef.disableClose = true;
        }

    closeModal(button: SessionTimeoutButtons) {
        this.dialogRef.close(button);
    }
}
